import {SimplePresentation} from "./SimplePresentationRunner";
import {Decadence} from "../../Decadence";
import {ReelWithSymbol} from "../../server/DecadenceModel";
import {DecadenceSymbol} from "../../symbols/DecadenceSymbol";
import {gsap} from "gsap"
import {ArrayUtils} from "../../utils/ArrayUtils";

interface ParsedSymbolCopy {
    shouldCopy:boolean,
    changeTo:string,
}

export class DecadenceSymbolCopyPresentation extends SimplePresentation {

    static readonly SCALE_DURATIONS:{[key:number]:number} = {
        1: 0.15,
        2: 0.15,
        4: 0.07,
    };

    constructor() {
        super("CopySymbolPresentation");
    }

    protected skip() {
        super.skip();
    }

    shouldRun(): boolean {
       return Decadence.reelView.getActiveSymbols().length > 1;
    }

    buildTimeline() {
        const symbols = Decadence.reelView.getActiveSymbols();
        const numberOfReels = symbols.length;
        const scaleDur = DecadenceSymbolCopyPresentation.SCALE_DURATIONS[numberOfReels];

        symbols.forEach((s, reel) => {
            if(reel == symbols.length-1) return;

            const nextSymbol = symbols[reel+1];
            const shouldCopy = s.name.includes("SC") || (!nextSymbol.name.includes("SC") && Number(s.name) > Number(nextSymbol.name));
            if(shouldCopy) {
                const copyTL = gsap.timeline();
                const srcSymbol = Decadence.reelView.getSymbolAt(reel);
                const targetSym = Decadence.reelView.getSymbolAt(reel+1);
                copyTL.add(() => {
                    Decadence.soundPlayer.playSound("valueScale");
                })
                copyTL.add(srcSymbol.animateScale());
                copyTL.add(targetSym.animateScale(1.2, scaleDur));
                copyTL.add(() => {
                    Decadence.soundPlayer.playSound("valueAdd");
                })
                copyTL.add(targetSym.changeSymbol(srcSymbol.name));
                copyTL.add(targetSym.animateScale(1, scaleDur));
                copyTL.add(srcSymbol.animateScale(1));
                this.tl.add(copyTL, reel * 0.37);
                targetSym.name = srcSymbol.name;
            }
        })

        //this.parsedSymbolCopies.forEach((copyData, copyDataIndex) => {
        //    const copyTL = gsap.timeline();
        //    const srcSymbol = Decadence.reelView.getSymbolAt(copyData.from.reelID);
        //    copyTL.add(srcSymbol.animateScale());
        //    copyData.to.forEach((target, index) => {
        //        const symTL = gsap.timeline();
        //        const targetSym = Decadence.reelView.getSymbolAt(target.reelID);
        //        symTL.add(targetSym.animateScale(1.2, 0.15));
        //        symTL.add(() => {
        //            targetSym.changeSymbol(Decadence.model.parsedEvaluatedArea[target.reelID].symbol);
        //        })
        //        symTL.add(targetSym.animateScale(1, 0.15));
        //        copyTL.add(symTL, index==0 ? ">" : "<");
        //    })
        //    copyTL.add(srcSymbol.animateScale(1));
        //    tl.add(copyTL, ">")
        //});
    }
}